import React, { useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from "../../axios/axiosconf";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";
import Swal from "sweetalert2";

function ParametrosRDAUsuario() {
    const history = useHistory();
    const search = useLocation().search;
    const userId = new URLSearchParams(search).get("id");

    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(null);
    const [esAdminPersonal, setEsAdminPersonal] = useState(false);
    const [client, setClient] = useState([]);
    const [loading, setLoading] = useState(false);
    const [uploadingCert, setUploadingCert] = useState(false);
    const [usuario, setUsuario] = useState(null);

    const [repsCode, setRepsCode] = useState("");
    const [clientIdHercules, setClientIdHercules] = useState("");
    const [clientSecret, setClientSecret] = useState("");
    const [env, setEnv] = useState("sandbox");
    const [hasCert, setHasCert] = useState(false);
    const [configured, setConfigured] = useState(false);
    const [errorlist, setErrorlist] = useState({});

    const cargarConfig = () => {
        if (!userId) return;
        axios
            .get(`/interop-user-configs/${userId}`)
            .then((response) => {
                const d = response.data || {};
                setUsuario(d.user || null);
                setRepsCode(d.reps_code || "");
                setClientIdHercules(d.hercules_client_id || "");
                setEnv(d.env || "sandbox");
                setHasCert(!!d.has_cert);
                setConfigured(!!d.configured);
                setClientSecret("");
            })
            .catch((error) => {
                console.error("Error al cargar configuración RDA:", error);
            });
    };

    useEffect(() => {
        if (!localStorage.getItem("userdata")) {
            setHasPermission(false);
            return;
        }

        if (!userId) {
            setHasPermission(false);
            return;
        }

        const userdata = JSON.parse(localStorage.getItem("userdata"));
        let permisosList = [];
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            permisosList = userdata.permissions.map((p) => p.slug);
        } else if (userdata.up) {
            permisosList = userdata.up;
        }

        const esAdmin = permisosList.includes("administrarPersonalProveedores");
        const esPropio = String(userId) === String(userdata.user_id);

        if (!esAdmin && !esPropio) {
            history.replace(`/parametros-rda-usuario?id=${userdata.user_id}`);
            return;
        }

        setHasPermission(true);
        setEsAdminPersonal(esAdmin);

        axios
            .get("/get-client?uid=" + userdata.user_id)
            .then((response) => {
                if (response.status === 200) {
                    setClient(response.data);
                }
                setLoggedIn(true);
            })
            .catch(() => setLoggedIn(true));

        cargarConfig();
    }, [userId]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorlist({});

        const data = {
            reps_code: repsCode,
            hercules_client_id: clientIdHercules,
            env,
        };
        if (clientSecret.trim() !== "") {
            data.hercules_client_secret = clientSecret;
        }

        axios
            .post(`/interop-user-configs/${userId}`, data)
            .then(() => {
                setLoading(false);
                Swal.fire({
                    icon: "success",
                    title: "Guardado",
                    text: "Parámetros RDA del usuario actualizados.",
                    confirmButtonColor: "#17a2b8",
                });
                cargarConfig();
            })
            .catch((err) => {
                setLoading(false);
                if (err.response && err.response.data.errors) {
                    setErrorlist(err.response.data.errors);
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: err.response?.data?.message || "No se pudo guardar.",
                        confirmButtonColor: "#17a2b8",
                    });
                }
            });
    };

    const handleCertChange = (e) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("certificate", file);

        setUploadingCert(true);
        axios
            .post(`/interop-user-configs/${userId}/certificate`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            })
            .then((response) => {
                setUploadingCert(false);
                setHasCert(true);
                Swal.fire({
                    icon: "success",
                    title: "Certificado cargado",
                    text: response.data?.message || "PEM guardado correctamente.",
                    confirmButtonColor: "#17a2b8",
                });
                e.target.value = "";
            })
            .catch((err) => {
                setUploadingCert(false);
                Swal.fire({
                    icon: "error",
                    title: "Error al subir PEM",
                    text: err.response?.data?.message || "Archivo no válido.",
                    confirmButtonColor: "#17a2b8",
                });
                e.target.value = "";
            });
    };

    const handleDeleteCert = () => {
        Swal.fire({
            title: "¿Eliminar certificado PEM?",
            text: "El usuario dejará de tener certificado mTLS hasta cargar uno nuevo.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (!result.isConfirmed) return;
            axios
                .delete(`/interop-user-configs/${userId}/certificate`)
                .then(() => {
                    setHasCert(false);
                    Swal.fire({
                        icon: "success",
                        title: "Eliminado",
                        confirmButtonColor: "#17a2b8",
                    });
                })
                .catch((err) => {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: err.response?.data?.message || "No se pudo eliminar.",
                        confirmButtonColor: "#17a2b8",
                    });
                });
        });
    };

    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (hasPermission !== true || !loggedIn) {
        return <Loading />;
    }

    const nombreUsuario = usuario
        ? `${usuario.name || ""} ${usuario.lastname || ""}`.trim()
        : "Usuario";

    return (
        <div className="wrapper hold-transition" style={{ fontSize: "13px" }}>
            <Header client={client} />
            <Aside client={client} activelink="settings" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <ol className="breadcrumb float-sm-left mb-0">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/settings">Configuración</Link></li>
                                    <li className="breadcrumb-item"><Link to="/personal-proveedores">Personal y proveedores</Link></li>
                                    {esAdminPersonal && (
                                        <li className="breadcrumb-item"><Link to="/parametros-rda">Parámetros RDA</Link></li>
                                    )}
                                    <li className="breadcrumb-item active">{esAdminPersonal ? nombreUsuario : "Mis parámetros RDA"}</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2 align-items-end">
                            <div className="col-md-8">
                                <h1 className="dash-title m-0">
                                    {esAdminPersonal ? `Parámetros RDA — ${nombreUsuario}` : "Mis parámetros RDA"}
                                </h1>
                                <p className="dash-subtitle mb-0 text-muted small">
                                    Credenciales personales Hércules y certificado PEM. Solo usted puede verlas y editarlas.
                                </p>
                            </div>
                            <div className="col-md-4 mt-2 mt-md-0 text-md-right">
                                <Link
                                    to={esAdminPersonal ? "/parametros-rda" : "/personal-proveedores"}
                                    className="btn btn-outline-secondary btn-sm"
                                    style={{ borderRadius: "10px", fontWeight: 600 }}
                                >
                                    <i className="fas fa-arrow-left mr-1"></i>
                                    {esAdminPersonal ? "Lista de usuarios" : "Volver"}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="card shadow-sm" style={{ borderRadius: "12px" }}>
                                    <div className="card-header bg-white border-0 pt-4">
                                        <h3 className="card-title mb-0" style={{ fontWeight: 600 }}>
                                            Credenciales Hércules V2
                                        </h3>
                                        {configured && (
                                            <span className="badge badge-success ml-2">Configurado</span>
                                        )}
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="form-group">
                                                <label className="text-uppercase small font-weight-bold">Código REPS (12 dígitos)</label>
                                                <input
                                                    type="text"
                                                    className={`form-control ${errorlist.reps_code ? "is-invalid" : ""}`}
                                                    maxLength={12}
                                                    value={repsCode}
                                                    onChange={(e) => setRepsCode(e.target.value)}
                                                    style={{ borderRadius: "10px" }}
                                                />
                                                <div className="invalid-feedback">{errorlist.reps_code}</div>
                                            </div>
                                            <div className="form-group">
                                                <label className="text-uppercase small font-weight-bold">Client ID (Hércules)</label>
                                                <input
                                                    type="text"
                                                    className={`form-control ${errorlist.hercules_client_id ? "is-invalid" : ""}`}
                                                    value={clientIdHercules}
                                                    onChange={(e) => setClientIdHercules(e.target.value)}
                                                    style={{ borderRadius: "10px" }}
                                                />
                                                <div className="invalid-feedback">{errorlist.hercules_client_id}</div>
                                            </div>
                                            <div className="form-group">
                                                <label className="text-uppercase small font-weight-bold">Client Secret (Hércules)</label>
                                                <input
                                                    type="password"
                                                    className={`form-control ${errorlist.hercules_client_secret ? "is-invalid" : ""}`}
                                                    placeholder={configured ? "Dejar en blanco para no cambiar" : "Obligatorio en el primer guardado"}
                                                    value={clientSecret}
                                                    onChange={(e) => setClientSecret(e.target.value)}
                                                    style={{ borderRadius: "10px" }}
                                                />
                                                <small className="form-text text-muted">
                                                    Secreto del portal IHCE – Administración de llaves. No se muestra después de guardar.
                                                </small>
                                                <div className="invalid-feedback">{errorlist.hercules_client_secret}</div>
                                            </div>
                                            <div className="form-group">
                                                <label className="text-uppercase small font-weight-bold">Ambiente</label>
                                                <select
                                                    className="form-control"
                                                    value={env}
                                                    onChange={(e) => setEnv(e.target.value)}
                                                    style={{ borderRadius: "10px" }}
                                                >
                                                    <option value="sandbox">Sandbox (pruebas)</option>
                                                    <option value="production">Producción</option>
                                                </select>
                                            </div>
                                            <button
                                                type="submit"
                                                className="btn btn-info px-4 py-2"
                                                style={{ borderRadius: "10px", fontWeight: 600 }}
                                                disabled={loading}
                                            >
                                                {loading ? (
                                                    <span className="spinner-border spinner-border-sm mr-2"></span>
                                                ) : (
                                                    <i className="fas fa-save mr-2"></i>
                                                )}
                                                Guardar parámetros
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-5">
                                <div className="card shadow-sm" style={{ borderRadius: "12px", background: "#f8f9fa" }}>
                                    <div className="card-body">
                                        <h5 style={{ fontWeight: 700, color: "#17a2b8" }}>Certificado PEM (mTLS)</h5>
                                        <p className="small text-muted">
                                            Si el nodo VULCANO exige certificado de cliente, cárguelo aquí (.pem). Se almacena de forma segura por usuario.
                                        </p>
                                        <p className="mb-2">
                                            Estado:{" "}
                                            <span className={`badge badge-${hasCert ? "success" : "secondary"}`}>
                                                {hasCert ? "Certificado cargado" : "Sin certificado"}
                                            </span>
                                        </p>
                                        <div className="form-group mb-2">
                                            <input
                                                type="file"
                                                className="form-control-file"
                                                accept=".pem,.crt,.cer,.key"
                                                onChange={handleCertChange}
                                                disabled={uploadingCert}
                                            />
                                        </div>
                                        {uploadingCert && (
                                            <p className="small text-info mb-2">
                                                <span className="spinner-border spinner-border-sm mr-1"></span>
                                                Subiendo archivo…
                                            </p>
                                        )}
                                        {hasCert && (
                                            <button
                                                type="button"
                                                className="btn btn-outline-danger btn-sm"
                                                onClick={handleDeleteCert}
                                            >
                                                <i className="fas fa-trash-alt mr-1"></i>
                                                Quitar certificado
                                            </button>
                                        )}
                                        <hr />
                                        <p className="small text-muted mb-0">
                                            Las llaves y el PEM se usan únicamente cuando <strong>usted</strong> envía al RDA.
                                            Nadie más del consultorio puede consultar este formulario.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default ParametrosRDAUsuario;